function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// @ts-nocheck
import { CSVNotice, nl2br } from "./..";
import { Button, Descriptions, Modal, Result, Space, Spin, Steps, Typography, Upload } from 'antd';
import React from 'react';
import useImportModal from "./useImportModal";
import styles from "./index.module.css";
import { LoadingOutlined } from '@ant-design/icons';
var Dragger = Upload.Dragger;
var config = {
  rootUrl: 'excelsior'
};
var stateForUpload = function stateForUpload(importFile) {
  if (!importFile) return {
    status: 'progress'
  };
  if (importFile.state === 'pending' || importFile.state === 'buffering') return {
    status: 'progress',
    icon: /*#__PURE__*/React.createElement(LoadingOutlined, null)
  };
  return {
    status: 'finish'
  };
};
var stateForVerify = function stateForVerify(importFile) {
  if (!importFile) return {
    status: 'wait'
  };
  if (importFile.state === 'checking') return {
    status: 'progress',
    icon: /*#__PURE__*/React.createElement(LoadingOutlined, null)
  };
  if (['buffered', 'checked', 'importing', 'imported'].includes(importFile.state)) return {
    status: 'finish'
  };
  return {
    status: 'wait'
  };
};
var stateForImport = function stateForImport(importFile) {
  if (!importFile) return {
    status: 'wait'
  };
  if (importFile.state === 'importing') return {
    status: 'progress',
    icon: /*#__PURE__*/React.createElement(LoadingOutlined, null)
  };
  if (importFile.state === 'imported') return {
    status: 'finish'
  };
  return {
    status: 'wait'
  };
};
export var ImportModalContent = function ImportModalContent(props) {
  var _importFile$errors_co, _importFile$success_c, _importFile$create_co, _importFile$update_co;
  var importType = props.importType,
    _props$allowImportOnE = props.allowImportOnError,
    allowImportOnError = _props$allowImportOnE === void 0 ? false : _props$allowImportOnE,
    _props$debug = props.debug,
    debug = _props$debug === void 0 ? false : _props$debug,
    onCancel = props.onCancel,
    onCompleted = props.onCompleted;
  var _useImportModal = useImportModal({
      configuration: config,
      importType: importType,
      defaultImporter: props.importer,
      defaultImportFile: props.importFile,
      onCompleted: onCompleted
    }),
    importer = _useImportModal.importer,
    importFile = _useImportModal.importFile,
    onReset = _useImportModal.onReset,
    onImport = _useImportModal.onImport,
    onProcessImport = _useImportModal.onProcessImport;
  if (debug) {
    console.log("importer", importer);
    console.log("importFile", importFile);
  }
  var translate = props.translate || config.translate;

  //if (!importer) return null;
  var steps = [_objectSpread({
    title: translate ? translate('excelsior_modal.upload_file') : 'Upload file'
  }, stateForUpload(importFile)), _objectSpread({
    title: translate ? translate('excelsior_modal.verify_file') : 'Verify file'
  }, stateForVerify(importFile)), _objectSpread({
    title: translate ? translate('excelsior_modal.import_file') : 'Import file'
  }, stateForImport(importFile))];
  var StepsWizard = /*#__PURE__*/React.createElement(Steps, {
    style: {
      paddingRight: 30,
      marginBottom: 16
    },
    items: steps
  });
  if (!importFile || ['buffering', 'buffered', 'pending'].includes(importFile.state)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, StepsWizard, /*#__PURE__*/React.createElement(Spin, {
      delay: 200,
      spinning: ['buffering', 'pending'].includes(importFile === null || importFile === void 0 ? void 0 : importFile.state),
      tip: translate ? translate('excelsior_modal.uploading_file') : 'Uploading...'
    }, /*#__PURE__*/React.createElement(Space, {
      direction: "vertical",
      style: {
        width: '100%'
      }
    }, importer && importer.description && /*#__PURE__*/React.createElement(Typography.Paragraph, null, nl2br(importer.description)), /*#__PURE__*/React.createElement(Dragger, {
      name: "file",
      showUploadList: false,
      multiple: false,
      beforeUpload: onImport
    }, /*#__PURE__*/React.createElement("p", {
      className: "ant-upload-hint"
    }, translate ? translate('excelsior_modal.upload_format') : 'Upload a .xlsx or a .csv file')), importer && importer.notice && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography.Title, {
      style: {
        marginBottom: 0
      },
      level: 5
    }, /*#__PURE__*/React.createElement(Space, null, translate ? translate('excelsior_modal.expected_columns') : 'Expected cols', importer.sample_file && /*#__PURE__*/React.createElement("a", {
      className: styles.sampleFileLink,
      href: importer.sample_file,
      target: "_blank"
    }, translate ? translate('excelsior_modal.download_sample_file') : 'Download sample file'))), /*#__PURE__*/React.createElement(CSVNotice, {
      schema: importer.notice
    })))));
  }
  if (['checking', 'checked'].includes(importFile.state)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, StepsWizard, /*#__PURE__*/React.createElement(Spin, {
      delay: 200,
      spinning: ['checking'].includes(importFile === null || importFile === void 0 ? void 0 : importFile.state),
      tip: translate ? translate('excelsior_modal.checking_file') : 'Checking...'
    }, /*#__PURE__*/React.createElement(Descriptions, {
      bordered: true,
      className: styles.checkDescriptions,
      size: "small",
      colon: false,
      layout: "vertical",
      column: 4
    }, /*#__PURE__*/React.createElement(Descriptions.Item, {
      span: 4,
      label: translate ? translate('excelsior_modal.number_of_error_lines') : 'Error lines count'
    }, importFile.state === 'checking' ? '' : importFile.errors_count.toLocaleString()), /*#__PURE__*/React.createElement(Descriptions.Item, {
      span: 4,
      label: translate ? translate('excelsior_modal.number_of_success_lines') : 'Correct lines count'
    }, importFile.state === 'checking' ? '' : importFile.success_count.toLocaleString()), /*#__PURE__*/React.createElement(Descriptions.Item, {
      span: 2,
      label: translate ? translate('excelsior_modal.number_of_creation') : 'Create'
    }, importFile.state === 'checking' ? '' : importFile.create_count.toLocaleString()), /*#__PURE__*/React.createElement(Descriptions.Item, {
      span: 2,
      label: translate ? translate('excelsior_modal.number_of_update') : 'Update'
    }, importFile.state === 'checking' ? '' : importFile.update_count.toLocaleString())), /*#__PURE__*/React.createElement("div", {
      className: styles.actions
    }, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(Button, {
      onClick: onCancel,
      type: "text"
    }, translate ? translate('excelsior_modal.cancel') : 'Cancel'), /*#__PURE__*/React.createElement(Button, {
      onClick: onProcessImport,
      type: "primary"
    }, translate ? translate('excelsior_modal.import') : 'Import')))));
  }
  var stats = /*#__PURE__*/React.createElement(Descriptions, {
    bordered: true,
    className: styles.checkDescriptions,
    size: "small",
    colon: false,
    layout: "vertical",
    column: 4
  }, /*#__PURE__*/React.createElement(Descriptions.Item, {
    span: 4,
    label: translate ? translate('excelsior_modal.number_of_error_lines') : 'Error lines count'
  }, ((_importFile$errors_co = importFile.errors_count) === null || _importFile$errors_co === void 0 ? void 0 : _importFile$errors_co.toLocaleString()) || '0'), /*#__PURE__*/React.createElement(Descriptions.Item, {
    span: 4,
    label: translate ? translate('excelsior_modal.number_of_success_lines') : 'Correct lines count'
  }, ((_importFile$success_c = importFile.success_count) === null || _importFile$success_c === void 0 ? void 0 : _importFile$success_c.toLocaleString()) || '0'), /*#__PURE__*/React.createElement(Descriptions.Item, {
    span: 2,
    label: translate ? translate('excelsior_modal.number_of_creation') : 'Create'
  }, ((_importFile$create_co = importFile.create_count) === null || _importFile$create_co === void 0 ? void 0 : _importFile$create_co.toLocaleString()) || '0'), /*#__PURE__*/React.createElement(Descriptions.Item, {
    span: 2,
    label: translate ? translate('excelsior_modal.number_of_update') : 'Update'
  }, ((_importFile$update_co = importFile.update_count) === null || _importFile$update_co === void 0 ? void 0 : _importFile$update_co.toLocaleString()) || '0'));
  if (['importing', 'imported'].includes(importFile.state)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, StepsWizard, /*#__PURE__*/React.createElement(Spin, {
      delay: 200,
      spinning: ['importing'].includes(importFile === null || importFile === void 0 ? void 0 : importFile.state),
      tip: translate ? translate('excelsior_modal.importing_file') : 'Importing...'
    }, importFile.state == 'imported' && /*#__PURE__*/React.createElement(Result, {
      status: "success",
      title: translate ? translate('excelsior_modal.file_successfully_imported') : 'File successfully imported',
      extra: [/*#__PURE__*/React.createElement(Button, {
        type: "text",
        key: "reset",
        onClick: onCancel
      }, translate ? translate('excelsior_modal.finish_and_close') : 'Finish and close'), /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        key: "close",
        onClick: onReset
      }, translate ? translate('excelsior_modal.new_import') : 'New import')]
    }), stats));
  }
  if (importFile.state === 'error') {
    if (importFile.error_message == 'header_not_found') {
      return /*#__PURE__*/React.createElement(Result, {
        status: "error",
        title: translate ? translate('excelsior_modal.missing_header') : 'Error',
        subTitle: /*#__PURE__*/React.createElement("div", null, translate ? translate('excelsior_modal.following_headers_are_missing') : 'Error', ":\xA0", (importFile.missing_headers || []).join(', ')),
        extra: [/*#__PURE__*/React.createElement(Button, {
          type: "text",
          key: "reset",
          onClick: onCancel
        }, translate ? translate('excelsior_modal.finish_and_close') : 'Finish and close'), /*#__PURE__*/React.createElement(Button, {
          type: "primary",
          key: "close",
          onClick: onReset
        }, translate ? translate('excelsior_modal.new_import') : 'New import')]
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, StepsWizard, /*#__PURE__*/React.createElement(Result, {
      status: "error",
      title: translate ? translate('excelsior_modal.error_on_file') : 'Error',
      subTitle: importFile.error_file ? /*#__PURE__*/React.createElement("a", {
        href: importFile.error_file,
        target: "_blank"
      }, translate ? translate('excelsior_modal.click_here_for_download_error_file') : 'Error') : null,
      extra: [/*#__PURE__*/React.createElement(Button, {
        type: "text",
        key: "reset",
        onClick: onCancel
      }, translate ? translate('excelsior_modal.finish_and_close') : 'Finish and close'), /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        key: "close",
        onClick: onReset
      }, translate ? translate('excelsior_modal.new_import') : 'New import')]
    }));
  }
  return /*#__PURE__*/React.createElement("div", null, StepsWizard);
};
var ImportModal = function ImportModal(props) {
  var open = props.open,
    translate = props.translate,
    onCancel = props.onCancel,
    title = props.title;
  if (!open) return null;
  return /*#__PURE__*/React.createElement(Modal, {
    open: true,
    width: 1000,
    footer: false,
    title: title,
    onCancel: onCancel
  }, /*#__PURE__*/React.createElement(ImportModalContent, _extends({
    translate: translate
  }, props)));
};
export var configure = function configure(configuration) {
  config = _objectSpread(_objectSpread({}, config), configuration);
  return config;
};
export default ImportModal;